export default __webpack_public_path__ + "static/media/jcb.53a60ece.png";